"use client"

import { Grid01, Rows01 } from "@untitledui/icons"
import { useState } from "react"

import { PromptDisplayAsCards } from "@/components/admin/collabs/prompt-display-as-cards"
import { ButtonGroup, ButtonGroupItem } from "@/components/ui/button-group"
import type { TrackPromptSummary } from "@/types/contents"

import { PromptDisplayAsLists } from "./prompt-display-as-lists"

enum PromptDisplayModes {
  list = "list",
  card = "card",
}

const PROMPT_DISPLAY_MODE: PromptDisplayModes = PromptDisplayModes.list

/**
 * PromptDisplay picks which prompts editor UI to render for a collab,
 * via a CTA that toggles PromptDisplayAsLists and PromptDisplayAsCards
 * @param collabSlug - Collab slug used to build the track-prompt API routes.
 * @param trackPrompts - Prompts to render.
 * @returns The display-mode toggle and the chosen editor.
 */
export function PromptDisplay({
  collabSlug,
  trackPrompts,
}: {
  collabSlug: string
  trackPrompts: TrackPromptSummary[]
}) {
  const [promptDisplayMode, setPromptDisplayMode] =
    useState<PromptDisplayModes>(PROMPT_DISPLAY_MODE)

  return (
    <div className="flex flex-col gap-3">
      <div className="flex justify-start">
        <ButtonGroup
          size="sm"
          disallowEmptySelection
          selectedKeys={[promptDisplayMode]}
          onSelectionChange={(keys) => {
            const [mode] = [...keys]
            if (mode) setPromptDisplayMode(mode as PromptDisplayModes)
          }}
        >
          <ButtonGroupItem id={PromptDisplayModes.list} iconLeading={Rows01}>
            List
          </ButtonGroupItem>
          <ButtonGroupItem id={PromptDisplayModes.card} iconLeading={Grid01}>
            Card
          </ButtonGroupItem>
        </ButtonGroup>
      </div>

      {promptDisplayMode === PromptDisplayModes.list ? (
        <PromptDisplayAsLists
          collabSlug={collabSlug}
          trackPrompts={trackPrompts}
        />
      ) : (
        <PromptDisplayAsCards trackPrompts={trackPrompts} />
      )}
    </div>
  )
}
